module.exports = __webpack_public_path__ + "img/67.8f282ee1.jpg";